import { useState } from 'react'

import { Box, Icon, ProgressBar, Text, Tooltip } from '@factorialco/deprecated-design-system'
import { AnimatePresence } from 'framer-motion'

import i18n from 'modules/core/lib/i18n'

interface Props {
  needsAttention?: boolean
  needsAttentionTooltip?: string
  progress: number
}

export const GoalProgressBar: React.FC<Props> = ({
  needsAttention,
  needsAttentionTooltip,
  progress,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)

  return (
    <Box flexDirection="column" width="full" alignItems="flexStart" justifyContent="center">
      <ProgressBar percentage={progress} amount={progress} total={100} />
      <AnimatePresence initial={false}>
        {needsAttention && (
          <Box flexDirection="row" alignItems="center" height="s24">
            <Box.Motion
              initial={{ width: 0, opacity: 0 }}
              animate={{ opacity: 1, width: 'auto' }}
              exit={{ width: 0, opacity: 0 }}
              style={{ overflow: 'hidden' }}
            >
              <Tooltip.Dialog
                open={tooltipOpen}
                toggle={(value) => () => setTooltipOpen(value)}
                attachment="top center"
                label={needsAttentionTooltip}
                textAlign="center"
              >
                <Box gap="s4" flexDirection="row" alignItems="center">
                  <Icon.Small icon="circle" color="iconWarning" />
                  <Text.Normal size="200" whiteSpace="nowrap">
                    {i18n.t('performance_goals.goal_progress_bar.needs_attention')}
                  </Text.Normal>
                </Box>
              </Tooltip.Dialog>
            </Box.Motion>
          </Box>
        )}
      </AnimatePresence>
    </Box>
  )
}
